import CompanyFormNew2 from '@modules/admin/companies/Company.Form.New2'
import React, { useEffect, useState } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { DashboardHeader } from '../Admin.Header'
import ConsultationsApiClient from '@services/Consultations'
import './Company.Create.scss'

const CreateCompany = () => {
  const [specialities, setSpecialities] = useState()
  const [formData, setFormData] = useState()
  const [initialFormData, setInitialFormData] = useState()

  useEffect(() => {
    ConsultationsApiClient.speciality.index({ per_page: 1000 }).then((response) => {
      setSpecialities(response.data)
    })
  }, [])
  return (
    <>
      <DashboardHeader title={<Trans>Crear Compañía</Trans>}>
        <Link className="btn btn-primary" to={'/companies'}>
          <Trans>Volver</Trans>
        </Link>
      </DashboardHeader>
      <div className="container-fluid main-content">
        {specialities ? (
          <CompanyFormNew2
            specialities={specialities}
            status="create"
            formData={formData}
            setFormData={setInitialFormData}
            initialFormData={initialFormData}
            setInitialFormData={setFormData}
          />
        ) : null}
      </div>
    </>
  )
}

export default withTranslation()(CreateCompany)
